/**
 * @generated SignedSource<<4ac66c46ddfc5f6d6866c589b343e83b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdatePasswordMutationInput = {
  clientMutationId?: string | null;
  currentPassword: string;
  password: string;
};
export type PasswordEditChangeMutation$variables = {
  input: UpdatePasswordMutationInput;
};
export type PasswordEditChangeMutation$data = {
  readonly updatePassword: {
    readonly __typename: "Influencer";
    readonly hasPassword: boolean;
  } | {
    readonly __typename: "UpdatePasswordError";
    readonly message: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type PasswordEditChangeMutation = {
  response: PasswordEditChangeMutation$data;
  variables: PasswordEditChangeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPassword",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "UpdatePasswordError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PasswordEditChangeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updatePassword",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/)
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PasswordEditChangeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updatePassword",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "33f19d46a13e3081828edf4e8cf88381",
    "id": null,
    "metadata": {},
    "name": "PasswordEditChangeMutation",
    "operationKind": "mutation",
    "text": "mutation PasswordEditChangeMutation(\n  $input: UpdatePasswordMutationInput!\n) {\n  updatePassword(input: $input) {\n    __typename\n    ... on Influencer {\n      hasPassword\n      id\n    }\n    ... on UpdatePasswordError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4b6899da13ae9955114f81234ae902c5";

export default node;
